import { Card } from '@components/ui/card';
import { legalSections } from '@content/legal-sections';
import { getPublicHref, ROUTE } from '@utils/route-utils';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { FC } from 'react';

const LegalCards: FC = () => {
  const t = useTranslations();
  const sections = legalSections(t);

  return (
    <div className="flex flex-wrap gap-4">
      {sections.map(section => (
        <Link
          key={section.id}
          href={getPublicHref([ROUTE.LEGAL, section.id])}
          className="flex-1"
        >
          <Card className="flex h-36 flex-col justify-between">
            <h3 className="text-card-title text-foreground">{section.title}</h3>
            <p className="text-caption text-muted-foreground">
              {section.description}
            </p>
          </Card>
        </Link>
      ))}
    </div>
  );
};

export default LegalCards;
